export type TagManagerScriptProps = {
  propertyId: string;
};

export type AffirmScriptProps = {
  publicApiKey: string;
  scriptUrl: string;
};

export type SezzleScriptProps = {
  salePrice: string;
};

export const DISABLE_AFFIRM_TOTAL = 50;

export const DISABLE_SEZZLE_TOTAL = 50;

export type OrderDetailsProduct = {
  productSKU: string;
  price: number;
  quantity: number;
};

export type PixelScriptData = {
  products: Array<OrderDetailsProduct>;
  orderId: number;
  orderTotal: number;
  couponCode: string | null;
};

export type CustomerType = 1 | 0;
export type PixelScriptProps = PixelScriptData & { customerType: CustomerType };
